module.exports = __webpack_public_path__ + "static/img/preview.9485c09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/bayonetta-microsite/preview.png
// module id = 84
// module chunks = 2